import React from 'react';
import { Card, CardBody, CardImg, CardText, CardTitle } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import Details from '../../generic/Details';
import TimestampInfo from '../../generic/TimestampInfo';
import { opportunityShape } from '../../prop-types';
import OpportunityLink from '../OpportunityLink';

function OpportunityCard({ opportunity }) {
  const details = [
    { label: 'Start', value: opportunity.campaignStart },
    { label: 'End', value: opportunity.campaignEnd },
  ];

  return (
    <Card className="c-compact-card mb-3">
      <CardImg top width="100%" src={opportunity.logoUrl} />
      <CardBody className="c-compact-card__body">
        <CardTitle className="c-compact-card__title">
          <OpportunityLink className="popover-in-card" model={opportunity} />
        </CardTitle>
        <CardText className="mb-0">
          <span className="text-muted">Expected Revenue:</span>{' '}
          <CurrencyFormat
            name="expectedRevenue"
            className="text-muted"
            decimalScale={0}
            value={opportunity.expectedRevenue || 0}
            text
          />
        </CardText>
        <CardText className="mb-0">
          <span className="text-muted">Co Invest:</span>{' '}
          <CurrencyFormat
            name="coInvest"
            className="text-muted"
            decimalScale={0}
            value={opportunity.coInvest || 0}
            text
          />
        </CardText>
        <CardText className="mb-0">
          <span className="text-muted">Free Service:</span>{' '}
          <CurrencyFormat
            name="freeService"
            className="text-muted"
            decimalScale={0}
            value={opportunity.freeService || 0}
            text
          />
        </CardText>
        <CardText className="mb-0">
          <span className="text-muted">Net Client Budget External:</span>{' '}
          <CurrencyFormat
            name="netClientBudgetExternal"
            className="text-muted"
            decimalScale={0}
            value={opportunity.netClientBudgetExternal || 0}
            text
          />
        </CardText>
        <CardText className="mb-0">
          <span className="text-muted">WKZ Budget:</span>{' '}
          <CurrencyFormat
            name="wkzBudget"
            className="text-muted"
            decimalScale={0}
            value={opportunity.wkzBudget || 0}
            text
          />
        </CardText>
        <CardText>
          <span data-qa-field="op-campaignObjective">
            <span className="text-muted">Objective:</span>{' '}
            {opportunity.campaignObjective}
          </span>
        </CardText>
        <Details
          className="c-compact-card__details"
          labelClassName="c-compact-card__detail-label"
          data={details}
        />
        <div className="c-compact-card__timestamp">
          <TimestampInfo
            timestamp={opportunity.lastModified}
            actionName="lastModified"
            author={opportunity.lastModifiedBy}
            displayAttribute="inline"
            fromNow
          />
        </div>
      </CardBody>
    </Card>
  );
}

OpportunityCard.propTypes = {
  opportunity: opportunityShape.isRequired,
};

export default OpportunityCard;
